import React from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import { propertyMarkerIcon } from "@/lib/mapIcons";

const DR_CENTER = [18.7357, -70.1627];
const DR_ZOOM = 8;

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  React.useEffect(() => {
    if (typeof lat === "number" && typeof lng === "number") {
      map.flyTo([lat, lng], Math.max(map.getZoom(), 13));
    }
  }, [lat, lng, map]);
  return null;
}

/**
 * Interactive picker: click anywhere on the map to set the property location.
 */
export default function LocationPicker({ lat, lng, onChange, height = 260 }) {
  const hasCoords = typeof lat === "number" && typeof lng === "number";
  const center = hasCoords ? [lat, lng] : DR_CENTER;
  const zoom = hasCoords ? 13 : DR_ZOOM;

  return (
    <div
      className="rounded-lg overflow-hidden border border-border"
      style={{ height }}
      data-testid="location-picker"
    >
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={true} className="h-full w-full">
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickHandler onPick={onChange} />
        {hasCoords && <Recenter lat={lat} lng={lng} />}
        {hasCoords && <Marker position={[lat, lng]} icon={propertyMarkerIcon} />}
      </MapContainer>
    </div>
  );
}
